import { createApp } from 'vue'
import PageOverlay from './PageOverlay'

const el = '.kb-component--page-overlay'
const DOM = document.querySelector(el)

export default function (Store) {
    if (DOM && !DOM.hasAttribute('data-v-app')) {
        const component = createApp(PageOverlay).use(Store)
        const openOverlayAutomatically = !!DOM.dataset.test
        const contentComponentToShow = DOM.dataset.content

        component.mount(el)

        // the following initiation of the overlay is strictly for local dev purposes
        if (openOverlayAutomatically) {
            Store.commit(
                'main/set_page_overlay_content',
                contentComponentToShow
            )
            setTimeout(() => Store.commit('main/open_page_overlay'), 500)
        }
    }
}
